var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "button",
    focusable: "false",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 11,
    fill: "#5C9EAD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23C18.5228 23 23 18.5228 23 13C23 7.47715 18.5228 3 13 3C7.47715 3 3 7.47715 3 13C3 18.5228 7.47715 23 13 23ZM13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
    fill: "#5C9EAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.928 15.064C12.928 14.4027 13.0453 13.8427 13.28 13.384C13.5147 12.9147 13.856 12.3973 14.304 11.832C14.6667 11.3733 14.9333 10.984 15.104 10.664C15.2853 10.344 15.376 9.98667 15.376 9.592C15.376 9.13333 15.216 8.776 14.896 8.52C14.576 8.25333 14.1387 8.12 13.584 8.12C13.0827 8.12 12.5707 8.232 12.048 8.456C11.5253 8.66933 11.0133 8.984 10.512 9.4L10 8.392C10.4587 7.96533 11.0187 7.62933 11.68 7.384C12.3413 7.128 12.9973 7 13.648 7C14.5547 7 15.2907 7.22933 15.856 7.688C16.4213 8.14667 16.704 8.74933 16.704 9.496C16.704 10.0613 16.5813 10.552 16.336 10.968C16.0907 11.384 15.7227 11.8693 15.232 12.424C14.7733 12.9467 14.4213 13.4053 14.176 13.8C13.9307 14.1947 13.7813 14.6533 13.728 15.176L13.696 15.464H12.928V15.064ZM12.512 16.776H14.144V18.408H12.512V16.776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.76905bc063a56028708856575b088a7c.svg";
export { ForwardRef as ReactComponent };